import axios from 'axios'

export  const loginMeths  = axios.create({
  withCredentials: true,
  timeout: 15000,
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  }
})


export const axiosJson = axios.create({
  withCredentials: true,
  headers: {
        'content-type': 'application/json',
}
})


export const axiosJsonToken = axios.create({
  withCredentials: true,
  headers: {
        'content-type': 'application/json',
        'credentials': 'include',
        'Authorization': 'Bearer ' + localStorage.token + '',
}
})